import React from 'react';
import { ScoreBoard as StyledScoreBoard, ScoreText, SpecialBar, SpecialBarFill } from '../styles/StyledComponents';

interface ScoreBoardProps {
  score: number;
  highScore: number;
  coins: number;
  specialMeter: number;
}

const ScoreBoard: React.FC<ScoreBoardProps> = ({ score, highScore, coins, specialMeter }) => {
  return (
    <StyledScoreBoard>
      <ScoreText>점수: {score}</ScoreText>
      <ScoreText>최고 점수: {highScore}</ScoreText>
      <ScoreText>코인: {coins}</ScoreText>
      <SpecialBar>
        <SpecialBarFill width={specialMeter} />
      </SpecialBar>
    </StyledScoreBoard>
  );
};

export default ScoreBoard;
